module.exports = __webpack_public_path__ + "img/27_3.33bfcd84.png";